import { render, staticRenderFns } from "./PassareButton.vue?vue&type=template&id=38bdad2e"
import script from "./PassareButton.vue?vue&type=script&lang=js"
export * from "./PassareButton.vue?vue&type=script&lang=js"
import style0 from "./PassareButton.vue?vue&type=style&index=0&id=38bdad2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports